module.exports = __webpack_public_path__ + "img/percent-alt.90dbb893.svg";